import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import footerBg from "../assets/bg.webp";
import logo from "../assets/logo.webp";

const NAV_LINKS = [
  { to: "/2027/overview", label: "Overview", end: true },
  { to: "/2027/sessions", label: "Sessions" },
  { to: "/2027/speakers", label: "Speakers" },
  { to: "/2027/exhibition", label: "Exhibition" },
  { to: "/2027/awards", label: "Awards" },
  { to: "/2027/partners", label: "Partners" },
];

const REGISTER_URL = "https://hyseaevents.zohobackstage.in/HASA2027";

const navLinkClass = ({ isActive }) =>
  `hover:underline ${isActive ? "underline" : ""}`;

const mobileNavLinkClass = ({ isActive }) =>
  `py-2 hover:underline ${isActive ? "underline" : ""}`;

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="fixed top-0 left-0 w-full z-50 shadow-md"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="w-full">
        <div className="mx-auto max-w-9xl px-4 sm:px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" aria-label="Home">
              <img
                src={logo}
                alt="HYSEA"
                className="h-8 md:h-10 object-contain"
              />
            </Link>
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center w-full">
            <nav className="absolute left-1/2 -translate-x-1/2 flex items-center gap-6 text-white text-sm md:text-base">
              {NAV_LINKS.map(({ to, label, end }) => (
                <NavLink key={to} to={to} end={end} className={navLinkClass}>
                  {label}
                </NavLink>
              ))}
            </nav>

            <div className="ml-auto">
              <a
                href={REGISTER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block rounded-md bg-white px-4 md:px-5 py-2 text-sm font-semibold text-[#002F76] shadow-sm hover:bg-gray-100"
              >
                Register Now
              </a>
            </div>
          </div>

          {/* Mobile Toggle */}
          <button
            className="lg:hidden inline-flex items-center justify-center p-2 rounded-md text-white"
            onClick={() => setOpen((s) => !s)}
            aria-expanded={open}
            aria-label="Toggle navigation menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {open ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 8h16M4 16h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Nav */}
        {open && (
          <div className="lg:hidden bg-[#14328D] w-full px-4 pb-4">
            <nav className="flex flex-col gap-3 text-white text-base">
              {NAV_LINKS.map(({ to, label, end }) => (
                <NavLink
                  key={to}
                  to={to}
                  end={end}
                  onClick={() => setOpen(false)}
                  className={mobileNavLinkClass}
                >
                  {label}
                </NavLink>
              ))}

              <div className="pt-2">
                <a
                  href={REGISTER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpen(false)}
                  className="inline-block rounded-md bg-white px-4 py-2 text-sm font-semibold text-[#002F76] shadow-sm hover:bg-gray-100"
                >
                  Register Now
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
